import styled from "styled-components";
import banner from "../../images/loginImg.jpg";
import loginBanner from "../../images/loginBanner.jpg" // Import your mobile banner image

export const Loginwrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 140px 20px 50px;
  font-family: "Lato", sans-serif;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #f0fdf4 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .right {
    flex: 1 1 100%;
    max-width: 500px;
    min-height: 500px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 25px;
    padding: 60px 40px;
    align-self: center;
    box-shadow: 0 25px 50px rgba(74, 124, 89, 0.15);
    border: 2px solid rgba(74, 124, 89, 0.1);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      background: linear-gradient(90deg, #4A7C59, #2D5A27, #4A7C59);
    }

    .form {
      max-width: 400px;
      margin-inline: auto;
      width: 100%;

      h2 {
        font: normal normal 700 clamp(24px, 4vw, 32px)/clamp(28px, 4.5vw, 38px) "Lato", sans-serif;
        letter-spacing: 0px;
        color: #4A7C59;
        margin-bottom: clamp(10px, 2vw, 15px);
        text-align: center;
      }
      p {
        font-size: clamp(14px, 3vw, 16px);
        margin-bottom: clamp(20px, 4vw, 30px);
        color: #2D5A27;
        text-align: center;
        font-weight: 500;
        line-height: 1.4;
      }

      .otpBox {
        margin-bottom: clamp(25px, 5vw, 40px);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        overflow-x: auto;
      }
      .resend {
        margin-top: clamp(15px, 3vw, 20px);

        p {
          font-size: clamp(12px, 2.5vw, 14px);
          font-weight: 600;
          color: #64748b;
          line-height: 1.3;
        }
      }
    }
  }

  .left {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #f0fdf4 100%);
    min-height: 100vh;
    padding: clamp(20px, 4vw, 40px) clamp(15px, 3vw, 20px) clamp(20px, 4vw, 30px);
    
    .right {
      margin-right: 0;
      max-width: 90%;
      padding: clamp(20px, 4vw, 30px) clamp(15px, 3vw, 20px);
      min-height: auto;
      
      .form {
        h2 {
          font-size: clamp(22px, 4.5vw, 28px);
          line-height: 1.2;
        }
        
        p {
          font-size: clamp(13px, 3.2vw, 15px);
          line-height: 1.3;
        }
        
        .otpBox {
          margin-bottom: clamp(20px, 4vw, 30px);
        }
        
        .confirm {
          font-size: clamp(11px, 2.8vw, 13px) !important;
          margin-bottom: clamp(10px, 2vw, 15px) !important;
          
          p {
            font-size: clamp(11px, 2.8vw, 13px) !important;
            line-height: 1.2 !important;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 480px) {
    padding: clamp(15px, 3vw, 30px) clamp(10px, 2vw, 15px) clamp(15px, 3vw, 20px);
    
    .right {
      max-width: 95% !important;
      padding: clamp(15px, 3vw, 25px) clamp(10px, 2vw, 15px);
      min-height: auto;
      
      .form {
        max-width: 100%;
        
        h2 {
          font-size: clamp(24px, 5vw, 28px);
          line-height: 1.2;
        }
        
        p {
          font-size: clamp(14px, 3.5vw, 16px);
          line-height: 1.4;
        }
        
        .otpBox {
          margin-bottom: 30px;
        }
        
        .confirm {
          font-size: clamp(12px, 3vw, 14px) !important;
          margin-bottom: 15px !important;
          
          p {
            font-size: clamp(12px, 3vw, 14px) !important;
            line-height: 1.3 !important;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 400px) {
    padding: clamp(10px, 2vw, 20px) clamp(5px, 1vw, 8px) clamp(10px, 2.5vw, 15px);
    
    .right {
      max-width: 98% !important;
      padding: clamp(12px, 2.5vw, 20px) clamp(8px, 1.5vw, 12px);
      min-height: auto;
      
      .form {
        h2 {
          font-size: clamp(20px, 4.5vw, 24px);
          margin-bottom: 10px;
        }
        
        p {
          font-size: clamp(13px, 3.2vw, 15px);
          margin-bottom: 20px;
        }
        
        .otpBox {
          margin-bottom: 25px;
        }
        
        .confirm {
          font-size: clamp(11px, 2.8vw, 13px) !important;
          margin-bottom: 12px !important;
          
          p {
            font-size: clamp(11px, 2.8vw, 13px) !important;
            line-height: 1.2 !important;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 320px) {
    padding: clamp(8px, 1.5vw, 15px) clamp(4px, 1vw, 6px) clamp(8px, 2vw, 10px);
    
    .right {
      max-width: 100% !important;
      padding: clamp(10px, 2vw, 15px) clamp(6px, 1.5vw, 10px);
      min-height: auto;
      
      .form {
        h2 {
          font-size: clamp(18px, 4vw, 20px);
          margin-bottom: 8px;
        }
        
        p {
          font-size: clamp(12px, 3vw, 14px);
          margin-bottom: 15px;
        }
        
        .otpBox {
          margin-bottom: 20px;
        }
        
        .confirm {
          font-size: clamp(10px, 2.5vw, 12px) !important;
          margin-bottom: 10px !important;
          
          p {
            font-size: clamp(10px, 2.5vw, 12px) !important;
            line-height: 1.1 !important;
          }
        }
      }
    }
  }

  .rates-card {
    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    padding: 40px;
    border-radius: 20px;
    margin-top: 40px;
    border: 2px solid rgba(74, 124, 89, 0.1);
    box-shadow: 0 10px 30px rgba(74, 124, 89, 0.1);
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .rates-title {
    color: #4A7C59;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 25px;
    text-align: center;
    border-bottom: 3px solid #4A7C59;
    padding-bottom: 10px;
  }

  .rates-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
  }

  .rate-item {
    background: white;
    padding: 20px;
    border-radius: 15px;
    border: 2px solid rgba(74, 124, 89, 0.1);
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .rate-label {
    color: #4A7C59;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
  }

  .rate-value {
    font-size: 24px;
    font-weight: 700;
    color: #2D5A27;
  }

  .example-title {
    color: #4A7C59;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    text-align: center;
  }

  .table-container {
    overflow-x: auto;
    border-radius: 15px;
    box-shadow: 0 5px 15px rgba(74, 124, 89, 0.1);
  }

  .example-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 15px;
    overflow: hidden;
  }

  .example-table th {
    background: linear-gradient(135deg, #4A7C59, #2D5A27);
    color: white;
    padding: 15px 8px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
  }

  .example-table td {
    padding: 15px 8px;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    color: #2D5A27;
    border-bottom: 1px solid #f1f5f9;
  }

  .example-table tr:last-child td {
    border-bottom: none;
  }

  .example-table tr:nth-child(even) {
    background: #f8fafc;
  }

  @media only screen and (max-width: 768px) {
    .rates-card {
      padding: 30px 20px;
      margin-top: 30px;
    }

    .rates-title {
      font-size: 24px;
    }

    .rates-grid {
      gap: 15px;
    }

    .rate-item {
      padding: 15px;
    }

    .rate-label {
      font-size: 16px;
    }

    .rate-value {
      font-size: 20px;
    }

    .example-title {
      font-size: 20px;
    }

    .example-table th,
    .example-table td {
      padding: 12px 6px;
      font-size: 11px;
    }
  }

  @media only screen and (max-width: 480px) {
    .rates-card {
      padding: 20px 15px;
      margin-top: 20px;
    }

    .rates-title {
      font-size: 20px;
    }

    .rates-grid {
      gap: 12px;
    }

    .rate-item {
      padding: 12px;
    }

    .rate-label {
      font-size: 14px;
    }

    .rate-value {
      font-size: 18px;
    }

    .example-title {
      font-size: 18px;
    }

    .example-table th,
    .example-table td {
      padding: 10px 4px;
      font-size: 10px;
    }
  }

  @media only screen and (max-width: 320px) {
    .rates-card {
      padding: 15px 10px;
    }

    .rates-title {
      font-size: 18px;
    }

    .rate-item {
      padding: 10px;
    }

    .rate-label {
      font-size: 12px;
    }

    .rate-value {
      font-size: 16px;
    }

    .example-title {
      font-size: 16px;
    }

    .example-table th,
    .example-table td {
      padding: 8px 2px;
      font-size: 9px;
    }
  }
`;

export const FormWrapper = styled.div`
  margin-block: 28px;

  .inputBox {
    max-width: 640px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    & > div {
      flex: 1 1 240px;
      margin-bottom: 0;
      max-width: calc(50% - 10px);

      &.min-w100 {
        min-width: 100%;
      }
    }

    .otp-input {
      max-width: 73%;
    }

    &.panBox {
      width: 100%;
      max-width: 100%;
    }
  }

  .button {
    max-width: 300px;
    width: 100%;
    margin-top: 30px;
  }

  .subheading {
    font-size: 25px;
    color: #1e40af;
    line-height: 30px;
    font-weight: 600;

    &.small {
      font-size: 14px !important;
    }
  }

  @media only screen and (max-width: 540px) {
    .button {
      max-width: 100%;
    }
    .inputBox {
      & > div {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;


export const FormWrapper2 = styled.div`
      margin-block: 28px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

  .inputBox {
    max-width: 640px;
  

    & > div {
      flex: 1 1 240px;
      margin-bottom: 0;
      max-width: calc(50% - 10px);

      &.min-w100 {
        min-width: 100%;
      }
    }

    .otp-input {
      max-width: 100%;
    }

    &.panBox {
      width: 100%;
      max-width: 100%;
    }
  }

  .button {
    max-width: 300px;
    width: 100%;
    margin-top: 30px;
  }

  .subheading {
    font-size: 25px;
    color: #1e40af;
    line-height: 30px;
    font-weight: 600;

    &.small {
      font-size: 14px !important;
    }
  }

  @media only screen and (max-width: 540px) {
    .button {
      max-width: 100%;
    }
    .inputBox {
      & > div {
        max-width: 100%;
        width: 100%;
      }
    }
  }
`;